import { render, staticRenderFns } from "./basicTable.vue?vue&type=template&id=5a65ac7a&scoped=true"
import script from "./basicTable.vue?vue&type=script&lang=js"
export * from "./basicTable.vue?vue&type=script&lang=js"
import style0 from "./basicTable.vue?vue&type=style&index=0&id=5a65ac7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65ac7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a65ac7a')) {
      api.createRecord('5a65ac7a', component.options)
    } else {
      api.reload('5a65ac7a', component.options)
    }
    module.hot.accept("./basicTable.vue?vue&type=template&id=5a65ac7a&scoped=true", function () {
      api.rerender('5a65ac7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/receivableManagementSite/aRGenerationNew/cmp/FeeDetail/basicTable.vue"
export default component.exports